exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-43125293] {\n  margin: 20px 0;\n}\ni.rejected[data-v-43125293] {\n  width: 100%;\n  color: red;\n  font-size: 60px;\n  justify-content: flex-end;\n}\n.thumb-image[data-v-43125293]:hover {\n  border: 1px solid black;\n  cursor: pointer;\n}", ""]);

// exports
